import { createContext, useContext } from "react";
import type { InventoryWareHouse } from "../models/InventoryWareHouse";
export interface WarehouseContextValue {
  Warehouse?: InventoryWareHouse;
  Warehouses: InventoryWareHouse[];
  Loading: boolean;
  Error: string;
  SelectWarehouse: (code: string) => void;
  Reload: () => void;
}
export const WarehouseContext = createContext<
  WarehouseContextValue | undefined
>(undefined);
export function useWarehouse() {
  const c = useContext(WarehouseContext);
  if (!c) throw new Error("WarehouseProvider is required");
  return c;
}
